module.exports = __webpack_public_path__ + "static/img/4402_phase_function_Paper_Points.de1c805.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4402_phase_function_Paper_Points.png
// module id = 6eIZ
// module chunks = 0